import { render, staticRenderFns } from "./App.vue?vue&type=template&id=973982c8&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports